import { expose } from 'comlink';
  import{SceneTileCalculator}from"../offline/MapTileCache";import pako from"pako";export function gzippedSize(data){const output=pako.deflate(new TextEncoder().encode(data));return output.byteLength;}let sceneCalculator;export function getSceneTileCalculator(){if(!sceneCalculator){sceneCalculator=new SceneTileCalculator();}return sceneCalculator;}export async function getTilesForScene(){return getSceneTileCalculator().getTilesForScene.apply(getSceneTileCalculator(),// @ts-ignore
arguments);}export async function countChildTiles(){const calculator=getSceneTileCalculator().calculator;return calculator.countChildTiles.apply(calculator,// @ts-ignore
arguments);};
  expose(
    Object.keys(__webpack_exports__).reduce(function(r,k){
      if (k=='__esModule') return r;
      r[k] = __webpack_exports__[k];
      return r
    },{})
  )